export const QUERY_OPERATORS = {
  inc: "inc", // IncludesString
  exc: "exc", // ExcludesString
  eq: "eq", // EqualsString
  neq: "neq", // NotEquals
  lt: "lt", // LessThan
  gt: "gt", // GreaterThan
  lte: "lte", // LessThanOrEqual
  gte: "gte", // GreaterThanOrEqual
  empty: "empty", // IsEmpty
  nempty: "nempty", // IsNotEmpty
} as const;

export type QueryOperator =
  (typeof QUERY_OPERATORS)[keyof typeof QUERY_OPERATORS];
